import { useState, useCallback, useEffect } from 'react';
import cls from 'classnames';

import formatForAnalytics from '../../../utils/formatForAnalytics';
import NewLabel from '../../core/NewLabel';

import { LinkBatchProps } from './types';
import useStyles from './linkBatchStyles';
import { FooterTitle } from './FooterTitle';

export function LinkBatch({
  title,
  expanded,
  items,
  onClick,
  isExpandable,
  isLast,
  analytics,
  pageName,
}: LinkBatchProps) {
  const classes = useStyles({ isExpandable });
  const [isExpanded, setIsExpanded] = useState(expanded);
  const showTitle = !isLast || isExpandable;
  const showLinks = !isExpandable || isExpanded;
  const onTitleClick = useCallback(() => {
    const event = isExpanded ? 'footer_link_group_close' : 'footer_link_group_expand';

    analytics.sendGaEvent(event, {
      page_name: pageName,
      action_type: formatForAnalytics(title),
    });

    setIsExpanded(!isExpanded);
  }, [isExpanded, analytics]);

  // this is done after hydration, helps on mobile side (next.js prebuilds only for desktop).
  useEffect(() => {
    setIsExpanded(expanded);
  }, []);

  return (
    <section className={classes.root}>
      {showTitle && (
        <FooterTitle isExpandable={isExpandable} onClick={onTitleClick} isExpanded={isExpanded}>
          {title}
        </FooterTitle>
      )}

      {showLinks && (
        <ul
          className={cls(
            classes.content,
            isExpandable ? classes.expandable : classes.nonExpandable,
          )}
        >
          {items.map(({ href, text, isNew }) => (
            <li key={text} className={classes.item}>
              <a
                href={href}
                target="_blank"
                className={cls(
                  classes.link,
                  'footer-batch-link',
                  isExpandable && classes.linkExpandable,
                )}
                onClick={() => onClick(formatForAnalytics(text))}
                rel="noreferrer"
              >
                <span className={classes.text}>{text}</span>
                {isNew && <NewLabel size="small" className={classes.new} />}
              </a>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
